import PageStorage from "../storage/page-storage";

export default function reducer(state = new PageStorage(), action) {
  let newState;
  switch (action.type) {
    case "SET_KIND":
    case "SET_MAKE":
    case "SET_ORDER":
    case "SET_PAGESIZE":
    case "SET_QUERY": {
      newState = new PageStorage({ ...state });
      newState.setPageNumber(0);
      return newState;
    }
    case "SET_PAGE_NUMBER": {
      newState = new PageStorage({ ...state });
      newState.setPageNumber(action.pageNumber);
      return newState;
    }
    case "REFRESH_PAGE":
      newState = new PageStorage({ ...state });
      newState.setPage(action.pageName);
      newState.setRefresh(true);
      return newState;
    case "SET_ERROR_PAGE":
    case "SET_PAGE": {
      newState = new PageStorage({ ...state });
      newState.setPage(action.pageName);
      newState.setMessage(action.text);
      return newState;
    }
    case "SET_DELTA_ERROR": {
      newState = new PageStorage({ ...state });
      newState.setPage(action.pageName);
      newState.setMessage(action.text);
      newState.setDeltaError(action.text)
      return newState;
    }
    default: return state;
  }
}
